import { useQuery } from '@tanstack/react-query';

import type { ProjectsPayload } from 'lib/saba/projects';

export default function useProjects() {
  return useQuery<ProjectsPayload>({
    queryKey: [ 'saba:projects' ],
    queryFn: async({ signal }) => {
      const response = await fetch('/node-api/saba-projects', { signal });
      if (!response.ok) throw new Error('دریافت فهرست پروژه‌ها ناموفق بود');
      return response.json() as Promise<ProjectsPayload>;
    },
    staleTime: 30_000,
    refetchInterval: 30_000,
    retry: 1,
  });
}
